module.exports = __webpack_public_path__ + "img/lie.4ad9b95d.svg";